<template>
  <div class="container">
    <div class="content-wrapper">
<!--      <div class="page-header">-->
<!--        <h1>知识库</h1>-->
<!--        <div class="page-subtitle">专业的设备维修知识库，涵盖故障诊断、维修技巧、保养方法等全方位知识</div>-->
<!--      </div>-->

      <!-- 整体卡片（标签 + 内容 / 详情） -->
      <div class="card">
        <!-- 详情视图：整张卡片切换 -->
        <div v-if="activeArticle" class="card-body card-body-content">
          <div class="article-detail">
            <button type="button" class="article-back-btn" @click="backToList">
              <el-icon>
                <ArrowLeft />
              </el-icon>
              <span>返回列表</span>
            </button>

            <!-- 针对 SUP-300 的文章详情 -->
            <div v-if="activeArticle" class="article-detail-content" v-html="content"/>
          </div>
        </div>

        <!-- 列表视图：标签 + 列表一并显示在卡片内 -->
        <template v-else>
          <!-- 分类标签 -->
          <div class="card-body card-body-tabs">
            <div class="tabs-wrapper">
              <div
                  v-for="(i, index) in categories"
                  :key="index"
                  :class="['tab-item', { 'tab-item-active': activeTab === index }]"
                  @click="handleTabClick(index)"
              >
                {{ i.title }}
              </div>
            </div>
          </div>

          <!-- 知识库内容 -->
          <div v-for="(i, index) in categories" :key="index">
            <div v-if="activeTab === index" class="knowledge-content">
              <div class="card-body card-body-content">
                <ul class="article-list">
                  <li
                      v-for="(article, index1) in i.dataList"
                      :key="index1"
                      class="article-item"
                  >
                    <div class="article-content">
                      <h4 class="article-title">
                        <strong>{{ article.title }}</strong>
                      </h4>
                      <div class="article-description">{{ article.description }}</div>
                    </div>
                    <div class="article-action">
                      <button type="button" class="article-btn" @click="openArticle(article.id)">
                        <el-icon>
                          <Reading />
                        </el-icon>
                        <span>阅读</span>
                      </button>
                    </div>
                  </li>
                </ul>

                <!-- 更多内容提示 -->
                <div class="placeholder-content">
                  <div class="placeholder-text">更多内容开发中...</div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  background: #f5f6fa;
}

.content-wrapper {
  margin: auto;
  width: 60rem;
  padding: 1.5rem;
}

.page-header {
  text-align: center;
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 2rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #333;
}

.page-subtitle {
  font-size: 1rem;
  color: #666;
}

.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.card-disabled {
  opacity: 0.3;
}

.card-body {
  padding: 1.5rem;
}

.card-body-tabs {
  border-bottom: 1px solid #f0f0f0;
}

.card-body-content {
  padding-top: 1.25rem;
}

/* 详情视图 */
.article-detail {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.article-detail-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 1rem 0;
  text-align: center;
}

.article-section {
  margin-bottom: 1.5rem;
}

.article-section h3 {
  font-size: 1.25rem;
  margin: 0 0 0.75rem 0;
  color: #333;
}

.article-section h4 {
  font-size: 1.1rem;
  margin: 1rem 0 0.5rem 0;
  color: #444;
}

.article-section p {
  margin: 0 0 0.5rem 0;
  color: #555;
  line-height: 1.7;
}

.article-section ul,
.article-section ol {
  margin: 0 0 0.75rem 1.25rem;
  padding: 0;
}

.article-section li {
  margin-bottom: 0.4rem;
  line-height: 1.6;
}

.article-image {
  display: block;
  max-width: 100%;
  margin: 0.75rem auto;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.article-image-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
}

.article-image-row .article-image {
  flex: 1 1 45%;
  max-width: 45%;
}

.article-detail-description {
  margin-top: 0.75rem;
}

.article-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  margin-bottom: 0.5rem;
  padding: 0;
  font-size: 0.875rem;
  border: none;
  background: transparent;
  color: #666;
  cursor: pointer;
  transition: color 0.2s;
}

.article-back-btn:hover {
  color: #1890ff;
}

/* 标签页 */
.tabs-wrapper {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.tab-item {
  padding: 0.75rem 1.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s;
  border: 2px solid transparent;
}

.tab-item:hover {
  color: #1890ff;
  background: #e6f7ff;
}

.tab-item-active {
  color: #1890ff;
  background: #e6f7ff;
  border-color: #1890ff;
}

/* 分类头部 */
.category-header {
  text-align: center;
  margin-bottom: 2rem;
  padding: 2rem 0;
}

.category-header h2 {
  font-size: 2.25rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  color: #1890ff;
}

.category-header p {
  font-size: 1.125rem;
  color: #666;
  width: 50rem;
  margin: 0 auto;
}

/* 文章列表 */
.article-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.article-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1.25rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  background: #fafafa;
  transition: all 0.3s;
}

.article-item:hover {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
}

.article-content {
  flex: 1;
}

.article-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 0.75rem 0;
  color: #1890ff;
}

.article-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.article-tag {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
}

.article-tag-easy {
  background: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}

.article-tag-medium {
  background: #fff7e6;
  color: #fa8c16;
  border: 1px solid #ffd591;
}

.article-tag-hard {
  background: #fff1f0;
  color: #ff4d4f;
  border: 1px solid #ffccc7;
}

.article-tag-time {
  background: #e6f7ff;
  color: #1890ff;
  border: 1px solid #91d5ff;
}

.article-tag-read {
  background: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}

.article-tag-rating {
  background: #fff7e6;
  color: #fa8c16;
  border: 1px solid #ffd591;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.article-description {
  font-size: 1rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 0.75rem;
}

.article-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.article-tag-item {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  background: #fafafa;
  color: #666;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 0.8125rem;
}

.article-action {
  margin-left: 1rem;
  flex-shrink: 0;
}

.article-btn {
  padding: 0.5rem 1rem;
  background: #1890ff;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s;
}

.article-btn:hover {
  background: #40a9ff;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
}

.article-btn svg {
  width: 1em;
  height: 1em;
}
</style>

<script setup>
import {ref} from 'vue'
import {ElIcon, ElMessage} from 'element-plus'
import {ArrowLeft, Reading} from '@element-plus/icons-vue'
import axios from "axios";

const activeTab = ref(0)
// 当前阅读的文章
const activeArticle = ref(null)
const activeArticleCategoryKey = ref(null)

const categories = ref([])
// API 基础地址
const API_BASE_URL = process.env.VUE_APP_WEB_URL;

// 获取技术文章列表
async function loadKnowledgeList() {
  try {
    const res = await axios.get(`${API_BASE_URL}/website/getKnowledge/1/10`);
    categories.value = res.data.data
  } catch (error) {
    console.error('获取技术文章列表失败:', error);
    ElMessage.error('获取数据失败，请稍后重试');
  }
}

loadKnowledgeList()
// 标签点击时，顺便关闭详情视图
function handleTabClick(key) {
  activeTab.value = key
  activeArticle.value = null
  activeArticleCategoryKey.value = null
}

const content = ref('')
// 打开文章详情
async function openArticle(id) {
  const res = await axios.get(`${API_BASE_URL}/website/data/${id}`);
  content.value = res.data.data.content
  activeArticle.value = 1
}

// 返回列表视图
function backToList() {
  activeArticle.value = null
  activeArticleCategoryKey.value = null
}

</script>
